import React, { ReactNode } from 'react';
import { gsap } from 'gsap';

interface GlassPanelProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}

export default function GlassPanel({ children, className = '', delay = 0 }: GlassPanelProps) {
  const panelRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (panelRef.current) {
      // Initial state
      gsap.set(panelRef.current, {
        opacity: 0,
        y: 30,
      });

      // Animate in - removed scale effect
      gsap.to(panelRef.current, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        delay,
        ease: 'power3.out',
      });
    }
  }, [delay]);

  return (
    <div
      ref={panelRef}
      className={`
        relative
        bg-transparent
        rounded-2xl
        border-none
        shadow-none
        overflow-hidden
        ${className}
      `}
      style={{
        background: 'transparent',
      }}
    >

      <div className='relative z-10'>{children}</div>
    </div>
  );
}
